<template>
  <div class="jade-stepper-item">
    <jade-icon
      size="large"
      :use="icon"
      :color="computedColor"
    ></jade-icon>
    <jade-text
      size="large"
      weight="semibold"
      variant="text-large"
      :color="computedColor"
    >
      {{ name }}</jade-text
    >
    <jade-icon
      class="jade-stepper-item--arrow"
      :color="computedColor"
      v-if="hasNext"
      use="chevron-right"
    />
  </div>
</template>

<script>
import { JadeIcon, JadeText } from '../../index.js'
import COLOR_ENUM from '../../enums/colors.enum'

export default {
  name: 'JadeStepperItem',

  components: {
    JadeIcon,
    JadeText
  },

  props: {
    name: String,
    icon: String,
    actived: Boolean,
    hasNext: Boolean
  },
  computed: {
    computedColor () {
      return this.actived ? COLOR_ENUM.BRAND : COLOR_ENUM.LOW
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade-design-tokens/stone/color.css';

.jade-stepper-item {
  display: flex;
  gap: var(--global-space-100);
}
.jade-stepper-item--arrow {
  margin-left: var(--global-space-200);
  margin-right: var(--global-space-200);
  color: var(--theme-color-content-low);
  display: flex;
  align-items: center;
}
</style>
